import React from "react";
import {
    Box,
    Divider,
    Flex,
    Skeleton,
    SkeletonText,
    Stack,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";

const BookingPreorderSkeleton = () => {
    return (
        <Box maxW="560px">
            <Skeleton
                mx={ThemeSpaceVariable.Medium}
                mb={ThemeSpaceVariable.Medium}
                w={["80%", "450px"]}
                h="32px"
                maxW="full"
            />

            <Tabs gap={ThemeSpaceVariable.Medium}>
                <TabList
                    mb={ThemeSpaceVariable.Medium}
                    width="fit-content"
                    minWidth="100%"
                    maxW="full"
                    gap={ThemeSpaceVariable.Small}
                    pr={ThemeSpaceVariable.Medium}
                    pl={ThemeSpaceVariable.Medium}
                    alignItems="center"
                >
                    <Skeleton height="48px" width="250px" borderRadius="full" />
                    <Skeleton height="30px" width="180px" />
                </TabList>
                <Divider mb={ThemeSpaceVariable.Medium} />
                <TabPanels>
                    <TabPanel>
                        <Stack px={ThemeSpaceVariable.Medium} spacing={ThemeSpaceVariable.None}>
                            {Array.from({ length: 5 }).map((_, i) => (
                                <React.Fragment key={i}>
                                    <Flex
                                        justify="space-between"
                                        align="center"
                                        my={ThemeSpaceVariable.Medium}
                                    >
                                        <Stack>
                                            <Skeleton height="24px" width="200px" />
                                            <SkeletonText noOfLines={2} spacing="2" width="300px" />
                                            <Skeleton height="20px" width="60px" />
                                        </Stack>
                                        <Skeleton borderRadius="full" height="40px" width="40px" />
                                    </Flex>
                                    <Divider />
                                </React.Fragment>
                            ))}
                        </Stack>
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
};

export default BookingPreorderSkeleton;
